<template>
  <div>
    <v-container fluid class="d-flex" style="min-height: 90vh" fill-height>
      <v-row align="center" justify="center">
        <v-col cols="12">
          <v-card class="rounded-xl elevation-4 pa-6" color="#F5F7FA">
            <v-card-title class="justify-center pb-6">
              <span class="text-h5 font-weight-bold text-primary">{{
                $t("message.PreRegisterParkingMenu")
              }}</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pt-6">
              <v-container>
                <v-row justify="center" dense>
                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model="WorkPermitNo"
                      :label="$t('message.WorkPermitNumber')"
                      outlined
                      dense
                      clearable
                      prepend-inner-icon="mdi-briefcase-outline"
                    />
                  </v-col>
                     <v-col cols="12" md="3">
                    <v-text-field
                      v-model="Subject"
                      :label="$t('message.Subject')"
                      outlined
                      dense
                      clearable
                      prepend-inner-icon="mdi-calendar-text"
                    />
                  </v-col>
                </v-row>
                <v-row justify="center" dense>
                  <v-col cols="12" md="3">
                    <v-autocomplete v-model="ProjectSite" :items="ProjectSiteList" item-text="projectName"
                      item-value="projectID" outlined dense clearable prepend-inner-icon="mdi-map-marker">
                      <template v-slot:label>
                        {{ $t("message.ProjectSite") }}
                        <span style="color: red">*</span>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row justify="center" dense>
                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model="VisitorName"
                      outlined
                      dense
                      clearable
                      prepend-inner-icon="mdi-account"
                    >
                      <template v-slot:label>
                        {{ $t("message.FirstName") }} <span style="color: red">*</span>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model="VisitorLastName"
                      outlined
                      dense
                      clearable
                      prepend-inner-icon="mdi-account"
                    >
                      <template v-slot:label>
                        {{ $t("message.LastName") }}
                        <span style="color: red">*</span>
                      </template>
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row justify="center" dense>
                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model="Phone"
                      outlined
                      dense
                      type="tel"
                      inputmode="numeric"
                      maxlength="10"
                      clearable
                      prepend-inner-icon="mdi-phone"
                      @keydown="allowPhoneKeydown"
                      @paste.prevent="Phone = filterPhoneInput($event.clipboardData.getData('text'))"
                      @input="Phone = filterPhoneInput($event)"
                    >
                      <template v-slot:label>
                        {{ $t("message.PhoneNumber") }}
                        <span style="color: red">*</span>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model="Email"
                      :label="$t('message.Email')"
                      outlined
                      dense
                      clearable
                      prepend-inner-icon="mdi-email"
                    />
                  </v-col>
                </v-row>
                <v-row justify="center" dense>
                  <v-col cols="12" md="3">
                    <v-menu
                      v-model="menuStartDate"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="StartDateDisplay"
                          prepend-inner-icon="mdi-calendar"
                          outlined
                          dense
                          readonly
                          clearable
                          v-bind="attrs"
                          v-on="on"
                        >
                          <template v-slot:label>
                            {{ $t('message.StartDate') }} <span style="color: red">*</span>
                          </template>
                        </v-text-field>
                      </template>
                      <v-date-picker
                        v-model="StartDate"
                        :min="today"
                        @change="menuStartDate = false"
                      />
                    </v-menu>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-menu
                      ref="menuStartTime"
                      v-model="menuStartTime"
                      :close-on-click="!StartTimePickerDirty"
                      :close-on-content-click="false"
                      @input="onStartTimeMenuInput"
                      transition="scale-transition"
                      offset-x
                      :nudge-right="8"
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="StartTime"
                          prepend-inner-icon="mdi-clock-time-four-outline"
                          outlined
                          dense
                          placeholder="HH:mm"
                          maxlength="5"
                          inputmode="numeric"
                          v-bind="attrs"
                          v-on="on"
                          @keydown="allowTimeKeydown"
                          @paste.prevent="onStartTimeInput($event.clipboardData.getData('text'))"
                          @input="onStartTimeInput($event)"
                          @blur="onStartTimeBlur"
                        >
                          <template v-slot:label>
                            {{ $t('message.StartTime') }} <span style="color: red">*</span>
                          </template>
                        </v-text-field>
                      </template>
                      <v-time-picker
                        v-if="menuStartTime"
                        v-model="StartTimePicker"
                        full-width
                        format="24hr"
                        @input="onStartTimePickerInput"
                        @click:hour="onStartTimeHourClick"
                        @click:minute="onStartTimeMinuteClick"
                      />
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row justify="center" dense>
                  <v-col cols="12" md="3">
                    <v-menu
                      v-model="menuEndDate"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="EndDateDisplay"
                          prepend-inner-icon="mdi-calendar"
                          outlined
                          dense
                          readonly
                          clearable
                          v-bind="attrs"
                          v-on="on"
                        >
                          <template v-slot:label>
                            {{ $t('message.EndDate') }} <span style="color: red">*</span>
                          </template>
                        </v-text-field>
                      </template>
                      <v-date-picker
                        v-model="EndDate"
                        :min="today"
                        @change="menuEndDate = false"
                      />
                    </v-menu>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-menu
                      ref="menuEndTime"
                      v-model="menuEndTime"
                      :close-on-click="!EndTimePickerDirty"
                      :close-on-content-click="false"
                      @input="onEndTimeMenuInput"
                      transition="scale-transition"
                      offset-x
                      :nudge-right="8"
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="EndTime"
                          prepend-inner-icon="mdi-clock-time-four-outline"
                          outlined
                          dense
                          placeholder="HH:mm"
                          maxlength="5"
                          inputmode="numeric"
                          v-bind="attrs"
                          v-on="on"
                          @keydown="allowTimeKeydown"
                          @paste.prevent="onEndTimeInput($event.clipboardData.getData('text'))"
                          @input="onEndTimeInput($event)"
                          @blur="onEndTimeBlur"
                        >
                          <template v-slot:label>
                            {{ $t('message.EndTime') }} <span style="color: red">*</span>
                          </template>
                        </v-text-field>
                      </template>
                      <v-time-picker
                        v-if="menuEndTime"
                        v-model="EndTimePicker"
                        full-width
                        format="24hr"
                        @input="onEndTimePickerInput"
                        @click:hour="onEndTimeHourClick"
                        @click:minute="onEndTimeMinuteClick"
                        :allowed-hours="hour => hour !== 0"
                        :allowed-minutes="minute => true"
                      />
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row justify="center" dense>
                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model="LicensePlate"
                      outlined
                      dense
                      clearable
                      prepend-inner-icon="mdi-car"
                      @input="onLicensePlateInput"
                    >
                      <template v-slot:label>
                        {{ $t('message.LicensePlate') }} <span style="color: red">*</span>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-select
                      v-model="VehicleType"
                      :items="['Car', 'Motorcycle']"
                      outlined
                      dense
                      prepend-inner-icon="mdi-truck"
                    >
                      <template v-slot:label>
                        {{ $t('message.VehicleType') }} <span style="color: red">*</span>
                      </template>
                    </v-select>
                  </v-col>
                </v-row>
                <v-row justify="center" dense>
                  <v-col cols="12" md="3">
                    <v-autocomplete
                      v-model="Province"
                      :items="ProvinceList"
                      item-text="provinceName"
                      item-value="provinceID"
                      label="Province *"
                      outlined
                      dense
                      clearable
                      prepend-inner-icon="mdi-map-marker"
                    >
                      <template v-slot:label>
                        {{ $t('message.Province') }} <span style="color: red">*</span>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row justify="center" class="mt-6">
                  <v-col cols="12" md="4" class="d-flex justify-center">
                    <v-btn
                      color="primary"
                      width="150"
                      class="mr-4 white--text rounded-lg"
                      large
                      @click="OpenApproveDialog()"
                      >{{ $t('message.Next') }}</v-btn
                    >

                    <v-btn
                      color="error"
                      width="150"
                      class="white--text rounded-lg"
                      large
                      @click="BackToMainPage()"
                      >{{ $t('message.Cancel') }}</v-btn
                    >
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="PreRegisterDialog" persistent max-width="800px">
      <v-card class="rounded-xl elevation-6">
        <v-card-title
          class="d-flex align-center justify-space-between py-4"
          style="
            background: linear-gradient(90deg, #1976d2, #42a5f5);
            color: white;
          "
        >
          <span class="text-h6 font-weight-bold text-primary"
            >{{ $t('message.VisitorSummary') }}</span
          >
          <v-btn icon @click="PreRegisterDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-6">
          <v-simple-table class="mb-6 rounded-lg elevation-1">
            <template v-slot:default>
              <tbody>
                  <tr>
                  <td class="text-subtitle-2 font-weight-medium">{{ $t('message.Subject') }}</td>
                  <td class="text-right">
                    {{ Subject }}
                  </td>
                </tr>
                <tr>
                  <td class="text-subtitle-2 font-weight-medium">{{ $t('message.FullName') }}</td>
                  <td class="text-right">
                    {{ VisitorName }} {{ VisitorLastName }}
                  </td>
                </tr>
                <tr>
                  <td class="text-subtitle-2 font-weight-medium">{{ $t('message.PhoneNumber') }}</td>
                  <td class="text-right">{{ Phone }}</td>
                </tr>
                <tr>
                  <td class="text-subtitle-2 font-weight-medium">{{ $t('message.Email') }}</td>
                  <td class="text-right">{{ Email }}</td>
                </tr>
                <tr>
                  <td class="text-subtitle-2 font-weight-medium">{{ $t('message.Duration') }}</td>
                  <td class="text-right">
                    {{
                      StartDate && EndDate
                        ? StartDate +
                          " " +
                          StartTime +
                          " - " +
                          EndDate +
                          " " +
                          EndTime
                        : ""
                    }}
                  </td>
                </tr>
                <tr>
                  <td class="text-subtitle-2 font-weight-medium">
                    {{ $t('message.LicensePlate') }}
                  </td>
                  <td class="text-right">{{ LicensePlate }}</td>
                </tr>
                <tr>
                  <td class="text-subtitle-2 font-weight-medium">
                    {{ $t('message.VehicleType') }}
                  </td>
                  <td class="text-right">{{ VehicleType }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <h3 class="text-h6 font-weight-bold mb-4">{{ $t('message.OfficerApprove') }}</h3>
          <v-row justify="center">
            <v-col cols="12" md="9">
              <v-select
                v-model="EmailApprove"
                :items="EmailApproveList"
                item-text="emailDisplay"
                item-value="email"
                :label="$t('message.SelectApproverEmail')"
                dense
                outlined
                clearable
              />
            </v-col>
            <v-col cols="12" md="3">
              <v-btn
                block
                large
                color="success"
                class="rounded-lg"
                @click="CreatePreRegister()"
                >{{ $t('message.Submit') }}</v-btn
              >
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="LoadingDialog" persistent width="auto">
      <v-card
        class="pa-6 d-flex flex-column align-center justify-center"
        elevation="8"
        rounded="xl"
      >
        <v-progress-circular
          indeterminate
          color="indigo"
          size="70"
          width="6"
        ></v-progress-circular>
        <span class="mt-4 text-subtitle-1 font-weight-medium"
          >Loading, please wait...</span
        >
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import enurl from "@/api/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";

export default {
  name: "PreRegisterParking",
  data() {
    return {
      url: enurl.apiUrl,
      LoadingDialog: false,
      QRvalue: "",
      QRsize: 250,
      Username: this.$cookies.get("Username"),

      menuStartDate: false,
      menuEndDate: false,
      menuStartTime: false,
      menuEndTime: false,
      today: new Date().toISOString().substr(0, 10),

      WorkPermitNo: "",
      Subject: "",
      VisitorName: "",
      VisitorLastName: "",
      Phone: "",
      Email: "",
      StartDate: "",
      EndDate: "",
      StartTime: "",
      EndTime: "",
      StartTimePicker: "00:00",
      EndTimePicker: "00:00",
      StartTimePickerDirty: false,
      EndTimePickerDirty: false,
      ProvinceList: [],
      Province: null,
      LicensePlate: "",
      VehicleType: "",
      PreRegisterDialog: false,
      EmailApproveList: [],
      EmailApprove: null,
      ProjectSite: null,
      ProjectSiteList: [],
    };
  },

  async mounted() {
    let self = this;
    self.getDataMasterProvince();
    self.getDataEmailListForApprove();
    self.getDataDropdownProjectSite();
  },

  computed: {
    StartDateDisplay() {
      if (!this.StartDate) return "";
      let [year, month, day] = this.StartDate.split("-");
      return `${day}-${month}-${year}`;
    },
    EndDateDisplay() {
      if (!this.EndDate) return "";
      let [year, month, day] = this.EndDate.split("-");
      return `${day}-${month}-${year}`;
    },
  },

  methods: {
    filterPhoneInput(value) {
      if (!value) return "";
      return value.replace(/\D/g, "").slice(0, 10);
    },

    allowPhoneKeydown(event) {
      const controlKeys = [
        "Backspace",
        "Delete",
        "Tab",
        "Enter",
        "Escape",
        "ArrowLeft",
        "ArrowRight",
        "Home",
        "End",
      ];

      if (controlKeys.includes(event.key) || event.ctrlKey || event.metaKey) {
        return;
      }

      if (!/^\d$/.test(event.key)) {
        event.preventDefault();
        return;
      }

      const input = event.target;
      const nextValue =
        input.value.slice(0, input.selectionStart) +
        event.key +
        input.value.slice(input.selectionEnd);

      if (nextValue.replace(/\D/g, "").length > 10) {
        event.preventDefault();
      }
    },

    filterTimeInput(value) {
      if (!value) return "";
      const digits = value.replace(/\D/g, "").slice(0, 4);
      if (digits.length <= 2) return digits;

      const hour = Number(digits.slice(0, 2)) > 23 ? digits.charAt(0) : digits.slice(0, 2);
      if (hour.length < 2) return hour;

      let minute = digits.slice(2);
      if (Number(minute.charAt(0)) > 5) minute = "";

      return `${hour}:${minute}`;
    },

    allowTimeKeydown(event) {
      const controlKeys = [
        "Backspace",
        "Delete",
        "Tab",
        "Enter",
        "Escape",
        "ArrowLeft",
        "ArrowRight",
        "Home",
        "End",
      ];

      if (controlKeys.includes(event.key) || event.ctrlKey || event.metaKey) {
        return;
      }

      if (!/^\d$/.test(event.key)) {
        event.preventDefault();
        return;
      }

      const input = event.target;
      const nextValue =
        input.value.slice(0, input.selectionStart) +
        event.key +
        input.value.slice(input.selectionEnd);
      const digits = nextValue.replace(/\D/g, "");

      if (digits.length > 4) {
        event.preventDefault();
        return;
      }

      if (digits.length >= 2 && Number(digits.slice(0, 2)) > 23) {
        event.preventDefault();
        return;
      }

      if (digits.length >= 3 && Number(digits.charAt(2)) > 5) {
        event.preventDefault();
      }
    },

    normalizeTime(value) {
      if (!value) return "";
      const text = value.trim();
      let hour = null;
      let minute = null;

      if (/^\d{1,2}$/.test(text)) {
        hour = Number(text);
        minute = 0;
      } else if (/^\d{3,4}$/.test(text)) {
        hour = Number(text.slice(0, -2));
        minute = Number(text.slice(-2));
      } else {
        const match = text.match(/^(\d{1,2}):(\d{1,2})$/);
        if (!match) return text;
        hour = Number(match[1]);
        minute = Number(match[2]);
      }

      if (hour > 23 || minute > 59) return text;

      return `${hour.toString().padStart(2, "0")}:${minute
        .toString()
        .padStart(2, "0")}`;
    },

    isValidTime(value) {
      return /^([01]\d|2[0-3]):[0-5]\d$/.test(value);
    },

    getValidTime(value) {
      const time = this.normalizeTime(value);
      return this.isValidTime(time) ? time : "";
    },

    async onLicensePlateInput(value) {
      const text = value || "";
      if (/[^ก-ฮ0-9a-zA-Z]/.test(text)) {
        await Swal.fire({
          icon: "warning",
          width: 600,
          text: "ป้ายทะเบียนต้องไม่มีช่องว่างหรืออักขระพิเศษ !",
        });
      }
      this.LicensePlate = text.replace(/[^ก-ฮ0-9a-zA-Z]/g, "");
    },

    onStartTimeInput(value) {
      this.StartTimePickerDirty = true;
      this.StartTime = this.filterTimeInput(value);
      const time = this.getValidTime(this.StartTime);
      if (time) this.StartTimePicker = time;
    },

    onEndTimeInput(value) {
      this.EndTimePickerDirty = true;
      this.EndTime = this.filterTimeInput(value);
      const time = this.getValidTime(this.EndTime);
      if (time) this.EndTimePicker = time;
    },

    onStartTimeBlur() {
      this.StartTime = this.normalizeTime(this.StartTime);
      const time = this.getValidTime(this.StartTime);
      if (time) this.StartTimePicker = time;
    },

    onEndTimeBlur() {
      this.EndTime = this.normalizeTime(this.EndTime);
      const time = this.getValidTime(this.EndTime);
      if (time) this.EndTimePicker = time;
    },

    onStartTimePickerInput(value) {
      this.StartTimePickerDirty = true;
      this.StartTime = value;
      this.StartTimePicker = value;
    },

    onEndTimePickerInput(value) {
      this.EndTimePickerDirty = true;
      this.EndTime = value;
      this.EndTimePicker = value;
    },

    onStartTimeHourClick() {
      this.StartTimePickerDirty = true;
    },

    onEndTimeHourClick() {
      this.EndTimePickerDirty = true;
    },

    onStartTimeMinuteClick() {
      this.onStartTimePickerInput(this.StartTimePicker);
      this.menuStartTime = false;
    },

    onEndTimeMinuteClick() {
      this.onEndTimePickerInput(this.EndTimePicker);
      this.menuEndTime = false;
    },

    onStartTimeMenuInput(isOpen) {
      if (isOpen) {
        this.StartTimePickerDirty = false;
        this.menuEndTime = false;
      } else {
        this.StartTimePickerDirty = false;
      }
    },

    onEndTimeMenuInput(isOpen) {
      if (isOpen) {
        this.EndTimePickerDirty = false;
        this.menuStartTime = false;
      } else {
        this.EndTimePickerDirty = false;
      }
    },

    getDataMasterProvince() {
      let self = this;
      axios
        .get(`${self.url}Management/getDataMasterProvince`)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ProvinceList = response.data.data;
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 900,
            text: error,
          });
        });
    },

    getDataDropdownProjectSite() {
      let self = this;
      axios
        .get(`${self.url}Management/getDataDropdownProjectSite`)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ProjectSiteList = response.data.data;
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 900,
            text: error,
          });
        });
    },

    getDataEmailListForApprove() {
      let self = this;
      axios
        .get(`${self.url}Management/getDataEmailListForApprove`)
        .then(function (response) {
          if (response.data.status == 0) {
            self.EmailApproveList = response.data.data;
          }
          else if(response.data.status == 1){
            Swal.fire({
              icon: "warning",
              width: 600,
              text: response.data.message,
            })
            .finally(function () {
              self.$router.push("/MainMenu");
            });
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 900,
            text: error,
          });
        });
    },

    OpenApproveDialog() {
      let self = this;
      self.StartTime = self.normalizeTime(self.StartTime);
      self.EndTime = self.normalizeTime(self.EndTime);
      if (
        self.VisitorName == "" ||
        self.VisitorLastName == "" ||
        self.StartDate == "" ||
        self.EndDate == "" ||
        self.StartTime == "" ||
        self.EndTime == "" ||
        self.LicensePlate == "" ||
        self.VehicleType == "" ||
        self.Province == null ||
        self.Phone == "" || 
        self.Phone == null ||
        self.ProjectSite == null
      ) {
        Swal.fire({
          icon: "warning",
          width: 600,
          text: "กรุณากรอกข้อมูลสำหรับใช้ Pre Register ให้ครบถ้วน !",
        });
      }
      else if(!self.isValidTime(self.StartTime) || !self.isValidTime(self.EndTime)) {
        Swal.fire({
          icon: "warning",
          width: 600,
          text: "รูปแบบเวลาต้องเป็น HH:mm เช่น 08:00 หรือ 23:00 !",
        });
      }
      else {
        const hasSpace = /\s/;
        const hasSpecialChar = /[^ก-ฮ0-9a-zA-Z\s]/;
        if(hasSpace.test(self.LicensePlate) || hasSpecialChar.test(self.LicensePlate)) {
          Swal.fire({
            icon: "warning",
            width: 600,
            text: "ป้ายทะเบียนต้องมีเฉพาะตัวอักษรไทยและตัวเลขเท่านั้น ห้ามมีช่องว่างหรืออักขระพิเศษ !",
          });
          return;
        }
        else if(self.Phone.length != 10){
          Swal.fire({
            icon: "warning",
            width: 600,
            text: "หมายเลขโทรศัพท์ต้องมี 10 หลักเท่านั้น !",
          });
          return;
        }
        self.PreRegisterDialog = true;
      }
    },

    CreatePreRegister() {
      let self = this;
      if (self.EmailApprove == null) {
        Swal.fire({
          icon: "warning",
          width: 600,
          text: "กรุณาเลือก Email ที่ต้องการส่ง Approve !",
        });
      } else {
        self.LoadingDialog = true;
        let temp = {
          workpermit: self.WorkPermitNo,
          subject: self.Subject,
          firstname: self.VisitorName,
          lastname: self.VisitorLastName,
          phone: self.Phone,
          email: self.Email,
          startDate: self.StartDate,
          endDate: self.EndDate,
          startTime: self.StartTime,
          endTime: self.EndTime,
          licensePlate: self.LicensePlate,
          province: self.Province,
          vehicleType: self.VehicleType,
          emailApprove: self.EmailApprove,
          preRegisterType: 1,
          visitorType: 1,
          projectID: self.ProjectSite
        };
        axios
          .post(`${self.url}PreRegister/CreatePreRegister`, temp)
          .then(function (response) {
            if (response.data.status == 0) {
              Swal.fire({
                icon: "success",
                title: "Success",
                showConfirmButton: false,
                timer: 1500,
              });
              self.ClosePreRegisterDialog();
            }
          })
          .catch(function (error) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error,
            });
          })
          .finally(function () {
              self.LoadingDialog = false;
            });
      }
    },

    ClosePreRegisterDialog() {
      let self = this;
      self.EmailApprove = [];
      self.WorkPermitNo = "";
      self.Subject = "";
      self.VisitorName = "";
      (self.VisitorLastName = ""), (self.Phone = "");
      self.Email = "";
      self.Province = null;
      self.LicensePlate = "";
      self.StartDate = "";
      self.EndDate = "";
      self.StartTime = "";
      self.EndTime = "";
      self.StartTimePicker = "00:00";
      self.EndTimePicker = "00:00";
      self.ProjectSite = null;
      self.VehicleType = null;
      self.EmailApprove = null;
      self.PreRegisterDialog = false;
    },

    BackToManagePreRegister() {
      let self = this;
      self.$router.push("/ManagePreRegister");
    },

    BackToMainPage() {
      let self = this;
      self.$router.push("/MainMenu");
    },

    DisplayDateFormat(dateStr) {
      let [year, month, day] = dateStr.split("-");
      return `${day}-${month}-${year}`;
    },
  },
};
</script>
<style scoped>
</style>
    
